export const ruleKeys = [
  {
    key: 'amount',
    name: '实际消耗金额',
    unit: '元'
  },
  {
    key: 'paperUseAmount',
    name: '账面消耗金额',
    unit: '元'
  },
  {
    key: 'downNum',
    name: '激活数',
    unit: '个'
  },
  {
    key: 'createRoleNum',
    name: '创角数',
    unit: '个'
  },
  {
    key: 'createRoleCost',
    name: '创角成本',
    unit: '元'
  },
  {
    key: 'createRoleRoi1',
    name: '1日ROI',
    unit: '%'
  },
  {
    key: 'payRoleUserNum',
    name: '新增付费创角数',
    unit: '个'
  },
  {
    key: 'newPayCost',
    name: '新创角付费成本',
    unit: '元'
  },
  {
    key: 'newRolePayCntCost',
    name: '新创角每次付费成本',
    unit: '元'
  },
  {
    key: 'newRoleRate',
    name: '新创角回款率',
    unit: '%'
  },
  {
    key: 'sumMoney',
    name: '总流水',
    unit: '元'
  }
]

export const operatorData = [
  {
    label: '大于等于',
    value: '>='
  },
  {
    label: '等于',
    value: '='
  },
  {
    label: '大于',
    value: '>'
  },
  {
    label: '小于等于',
    value: '<='
  },
  {
    label: '小于',
    value: '<'
  },
  {
    label: '不等于',
    value: '!='
  }
]
